
import React, { useState } from 'react';
import { FaTimes, } from 'react-icons/fa';
import { format, subDays,  } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import 'react-datepicker/dist/react-datepicker.css';

const ModalExtrato = ({ extrato, onClose }) => {
  // Estado para controle do calendário
  const [startDate, setStartDate] = useState(subDays(new Date(), 7));
  const [endDate, setEndDate] = useState(new Date());


  // Formata a data no padrão brasileiro
  const formatDate = (date) => {
    return format(date, "dd/MM/yyyy", { locale: ptBR });
  };

  // Filtra o extrato pelo período selecionado
  const filteredExtrato = extrato.filter(item => {
    const itemDate = new Date(item.dataHora);
    return itemDate >= startDate && itemDate <= endDate;
  });
  
  // Estilos do modal (com ajustes para o novo layout)
  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      backgroundColor: '#fff',
      borderRadius: '12px',
      padding: '25px',
      width: '90%',
      maxWidth: '600px',
      maxHeight: '80vh',
      overflowY: 'auto',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      position: 'relative',
    },

    dateFilterContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      flexWrap: 'wrap',
      gap: '10px',
    },
    datePickerWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    datePickerLabel: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#495057',
    },
    datePickerInput: {
      padding: '8px 12px',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: '#fff',
    },
    calendarIcon: {
      color: '#09448C',
    },
    quickFilterButton: {
      padding: '6px 12px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '13px',
      ':hover': {
        backgroundColor: '#e9ecef',
      }
    },
    activeFilter: {
      backgroundColor: '#09448C',
      color: '#fff',
      borderColor: '#09448C',
    },

    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      borderBottom: '1px solid #e9ecef',
      paddingBottom: '15px',
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#09448C',
      margin: 0,
    },
    closeButton: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      color: '#6c757d',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    tableHeader: {
      backgroundColor: '#f8f9fa',
      textAlign: 'left',
      padding: '12px 15px',
      borderBottom: '1px solid #e9ecef',
      color: '#495057',
      fontWeight: '600',
    },
    tableRow: {
      borderBottom: '1px solid #e9ecef',
      ':hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    tableCell: {
      padding: '12px 15px',
      color: '#212529',
      verticalAlign: 'top',
    },
    produtoContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    produtoNome: {
      fontWeight: '600',
      marginBottom: '4px',
    },
    associadoNome: {
      fontSize: '12px',
      color: '#6c757d',
      fontStyle: 'italic',
    },
    emptyMessage: {
      textAlign: 'center',
      padding: '20px',
      color: '#6c757d',
      fontStyle: 'italic',
    },
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>Extrato de Lançamentos</h2>
          <button style={styles.closeButton} onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        {extrato.length > 0 ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Data/Hora</th>
                <th style={styles.tableHeader}>Produto</th>
                <th style={styles.tableHeader}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {extrato.map((item, index) => (
                <tr key={index} style={styles.tableRow}>
                  <td style={styles.tableCell}>{item.dataHora}</td>
                  <td style={styles.tableCell}>
                    <div style={styles.produtoContainer}>
                      <span style={styles.produtoNome}>{item.produto}</span>
                      {item.associado && (
                        <span style={styles.associadoNome}>Associado: {item.associado}</span>
                      )}
                    </div>
                  </td>
                  <td style={styles.tableCell}>{item.valor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={styles.emptyMessage}>Nenhum lançamento encontrado</p>
        )}
      </div>
    </div>
  );
};

export default ModalExtrato;